module.exports = __webpack_public_path__ + "media/images/client-dreams-766091ee511894f3cf978ff2de139709.svg";